import version from "../version.json";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import "../../src/App.css";
import metadata from "../common/metadata.json";
import { Spnp } from "../Components/Common/ProfileDropdown";
const Footer = () => {
  const { buildMajor, buildMinor, buildRevision, buildTag, buildDate } =
    metadata;
  const v1 = `${buildMajor}.${buildMinor}.${buildRevision}  Updated ${buildDate}`;
  return (
    <React.Fragment>
      <footer className="footer" style={{ background: "white" }}>
        <Container fluid>
          <div
            className={
              "d-flex justify-content-end footer-content-for-trade-mark-and-version-frame"
            }
          >
            <div>
              <div className={"d-flex flex-direction-row"}>
                <div>{new Date().getFullYear()} © CRMiT </div>
                <div className={"me-1 ms-2"}>
                  <span></span>
                  <a
                    href={"https://status.crmit.app"}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Service Status
                  </a>
                </div>
                <div></div>
              </div>
            </div>
            <div>
              <div className=" ">
                <span className={""}>Commit Version: </span>
                <span>{version.commit}</span>{" "}
                <span className={""}>Version: </span>
                <span>{v1}</span>
              </div>
            </div>
          </div>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
